export default __webpack_public_path__ + "static/hero-804a3e81de488caa4f7d237fc4a202b6.png";